import React from "react";
import "./Body.css";
import Contactform from "../../Components/Contactform/Contactform";
import { Container, Row, Col } from "reactstrap";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faTimes, faCheck } from "@fortawesome/free-solid-svg-icons";
library.add(faTimes, faCheck);


export default class Body extends React.Component {

    render() {
        return (
            <Container className="contact-wrapper p-b-0">
                <Row className="same-height">
                    <Col md="6" className="contact-content">
                        <h1 className="text-center">We are here <br />to help you!</h1>
                        <Row>
                           
                        </Row>
                    </Col>

                    <Col md="6"><Contactform /></Col>
                </Row>
            </Container >
        );
    }
}